export default __webpack_public_path__ + "static/media/btp-spinner.27ae79f9.svg";